"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * Represents a linked heading.
 * @public
 */
class LinkedHeading {
  /**
   * Class constructor.
   * @public
   * @param {HTMLElement} headingElement - The heading element in the DOM
   * @param {Object} [options={}] - An options object for configuring the linked heading
   * @param {String} [options.content="¶"] - The content to add to the created link
   * @param {String} [options.title="Link directly to this section of the page"] - The title attribute to add to the created link
   */
  constructor(headingElement) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.headingElement = headingElement;
    this.id = headingElement.getAttribute('id');
    this.options = Object.assign({}, {
      content: '#',
      title: 'Link directly to this section of the page'
    }, options);
    this.linkElement = this.constructLinkElement();
  }
  /**
   * Construct the heading link element. If a link element already exists inside the heading,
   * then this method will do nothing
   * @private
   * @returns {HTMLElement} Returns the new link element, or the existing link element if present
   */


  constructLinkElement() {
    if (!this.id) {
      return null;
    } // Check for an existing link element


    var existingAnchor = this.headingElement.querySelector('a');

    if (existingAnchor) {
      return existingAnchor;
    } // Create heading anchor.


    var headingText = this.headingElement.innerHTML.trim();
    var anchor = document.createElement("a");
    anchor.href = "#".concat(this.id);
    anchor.title = this.options.title;
    anchor.classList.add('o-layout__linked-heading__link');
    anchor.innerHTML = "\n\t\t\t<span class=\"o-layout__linked-heading__content\">".concat(headingText, "</span>\n\t\t\t<span class=\"o-layout__linked-heading__label\">").concat(this.options.content, "</span>\n\t\t");
    window.requestAnimationFrame(function () {
      this.headingElement.innerHTML = '';
      this.headingElement.classList.add('o-layout__linked-heading');
      this.headingElement.appendChild(anchor);
    }.bind(this));
    return anchor;
  }

} // Exports


var _default = LinkedHeading;
exports.default = _default;
module.exports = exports.default;